/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { BalanceStatus } from './BalanceStatus';
import {
    BalanceStatusFromJSON,
    BalanceStatusFromJSONTyped,
    BalanceStatusToJSON,
    BalanceStatusToJSONTyped,
} from './BalanceStatus';

/**
 * 
 * @export
 * @interface BalanceScrollQuery
 */
export interface BalanceScrollQuery {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof BalanceScrollQuery
     */
    userId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof BalanceScrollQuery
     */
    seasonId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof BalanceScrollQuery
     */
    studentId?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof BalanceScrollQuery
     */
    year?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof BalanceScrollQuery
     */
    month?: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {any}
     * @memberof BalanceScrollQuery
     */
    calculationDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof BalanceScrollQuery
     */
    currencyDate?: any | null;
    /**
     * 
     * @type {any}
     * @memberof BalanceScrollQuery
     */
    postingDate?: any | null;
    /**
     * 
     * @type {BalanceStatus}
     * @memberof BalanceScrollQuery
     */
    status?: BalanceStatus | null;
}



/**
 * Check if a given object implements the BalanceScrollQuery interface.
 */
export function instanceOfBalanceScrollQuery(value: object): value is BalanceScrollQuery {
    return true;
}

export function BalanceScrollQueryFromJSON(json: any): BalanceScrollQuery {
    return BalanceScrollQueryFromJSONTyped(json, false);
}

export function BalanceScrollQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceScrollQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'seasonId': json['seasonId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['seasonId']),
        'studentId': json['studentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'year': json['year'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['year']),
        'month': json['month'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['month']),
        'calculationDate': json['calculationDate'] == null ? undefined : json['calculationDate'],
        'currencyDate': json['currencyDate'] == null ? undefined : json['currencyDate'],
        'postingDate': json['postingDate'] == null ? undefined : json['postingDate'],
        'status': json['status'] == null ? undefined : BalanceStatusFromJSON(json['status']),
    };
}

export function BalanceScrollQueryToJSON(json: any): BalanceScrollQuery {
    return BalanceScrollQueryToJSONTyped(json, false);
}

export function BalanceScrollQueryToJSONTyped(value?: BalanceScrollQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'seasonId': ActorActivityRecordActorUserIdToJSON(value['seasonId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'year': ActorActivityRecordActorUserIdToJSON(value['year']),
        'month': ActorActivityRecordActorUserIdToJSON(value['month']),
        'calculationDate': value['calculationDate'],
        'currencyDate': value['currencyDate'],
        'postingDate': value['postingDate'],
        'status': BalanceStatusToJSON(value['status']),
    };
}

